import { useSelector } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { PhoneListItem } from './PhoneListItem';
import './PhoneList.scss';
import { selectSelectedBranch } from '../../features/bookingForm/selectors';
import { useWidgetProps } from '../../WidgetPropsContext';
import { getSelectedBranchesData } from '../../serviceBooking/store/selectors';

const phones = require('b_')
    .with('phone-list');

export const PhoneList = ({
    list,
    branch: userBranch,
    label,
}) => {
    const { serviceBooking } = useWidgetProps();
    const getPhones = phoneString => phoneString?.split?.(';');
    let items = [];
    const selectedBranch = useSelector(getSelectedBranchesData);
    const currentBranch = useSelector(selectSelectedBranch);
    if (serviceBooking && selectedBranch) {
        items = getPhones(selectedBranch?.phones);
    } else {
        const branch = userBranch ?? currentBranch;
        items = list?.length ? list : getPhones(branch?.phones ?? '');
    }
    return (
        <div className={phones()}>
            {label && <div className={phones('label')}>{label}</div>}
            {items?.map?.(item => (
                <PhoneListItem phone={item} key={item}/>
            ))}
        </div>
    );
};

PhoneList.propTypes = {
    list: PropTypes.arrayOf(PropTypes.string),
    branch: PropTypes.objectOf(PropTypes.any),
    label: PropTypes.string,
};

PhoneList.defaultProps = {
    list: [],
    branch: undefined,
    label: '',
};
